
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  disabled = false
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105 hover:shadow-lg active:scale-95';
  
  const variantClasses = {
    primary: 'bg-[#2DD4BF] text-[#0B1D2E] hover:bg-[#14B8A6] hover:shadow-xl',
    secondary: 'bg-[#0B1D2E] text-[#2DD4BF] hover:bg-[#1E293B] hover:shadow-xl',
    outline: 'border-2 border-[#2DD4BF] text-[#2DD4BF] hover:bg-[#2DD4BF] hover:text-[#0B1D2E] hover:shadow-xl'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-lg',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-xl'
  };
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className} ${
    disabled ? 'opacity-50 cursor-not-allowed hover:scale-100 hover:shadow-none' : ''
  }`;

  const handleClick = () => {
    if (href) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (onClick) {
      onClick();
    }
  };

  if (href) {
    return (
      <Link 
        to={href} 
        className={classes} 
        style={{ fontFamily: '"Open Sans", sans-serif' }}
        onClick={handleClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <button 
      onClick={handleClick} 
      className={classes} 
      disabled={disabled}
      style={{ fontFamily: '"Open Sans", sans-serif' }}
    >
      {children}
    </button>
  );
}
